export enum FixtureResultStatuses {
  Confirmed = "CONFIRMED",
  DidNotFinish = "DID_NOT_FINISH",
  DidNotStart = "DID_NOT_START",
  Disqualified = "DISQUALIFIED",
  Forfeited = "FORFEITED",
  InProgress = "IN_PROGRESS",
  Scheduled = "SCHEDULED",
  Withdrawn = "WITHDRAWN",
  WonByForfeit = "WON_BY_FORFEIT",
}
